import * as React from 'react';
import { getAttributionData, getIsBot, recordAttributionAnalytics } from '@/redux/modules/analytics';
import { useDispatch, useSelector } from 'react-redux';
import isEqual from 'react-fast-compare';
import usePrevious from '@/hooks/usePrevious';

/**
 * Record Segment.io attribution data on first page load
 */
const SegmentTracker = () => {
    const attributionData = useSelector(getAttributionData, isEqual);
    const isBot = useSelector(getIsBot);
    const prevBidderId = usePrevious(attributionData.bidderId);
    const dispatch = useDispatch();

    React.useEffect(() => {
        if (prevBidderId !== attributionData.bidderId && !isBot) {
            dispatch(recordAttributionAnalytics(attributionData));
        }
    }, [attributionData, isBot, prevBidderId, dispatch]);

    return null;
};

export default SegmentTracker;
